import React from "react";

const Badge = ({ text, bgColor, fontColor }) => {
  return (
    <div
      style={{
        border: "1px none",
        boxShadow: "0px 0px 5px #63636326",
        justifyContent: "center",
        alignSelf: "center",
        display: "flex",
        borderRadius: "5px",
        padding: "5px",
        backgroundColor: bgColor,
        color: fontColor,
        textTransform: "capitalize",
      }}
    >
      {text}
    </div>
  );
};

export default Badge;
